import { render, staticRenderFns } from "./StandardLayoutTitle.vue?vue&type=template&id=021346c7&scoped=true&"
import script from "./StandardLayoutTitle.vue?vue&type=script&lang=ts&"
export * from "./StandardLayoutTitle.vue?vue&type=script&lang=ts&"
import style0 from "./StandardLayoutTitle.vue?vue&type=style&index=0&id=021346c7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021346c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VFlex,VLayout,VToolbarTitle})
